const isItIframe = () => {
  return window.location !== window.parent.location;
};

export default isItIframe;
